import { render, staticRenderFns } from "./outsource-label.vue?vue&type=template&id=7085ac74&scoped=true&"
import script from "./outsource-label.vue?vue&type=script&lang=js&"
export * from "./outsource-label.vue?vue&type=script&lang=js&"
import style0 from "./outsource-label.vue?vue&type=style&index=0&id=7085ac74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085ac74",
  null
  
)

export default component.exports